export default "__VITE_ASSET__499f459c__"